import { Input } from "antd";
import React from "react";

const InputPassword = ({ placeholder, ...props }) => {
  const handleKeyDown = (event) => {
    const key = event.key;
    const isAllowedKey = /^[0-9\b]+$/.test(key);
    if (!isAllowedKey && key !== "Backspace") {
      event.preventDefault();
    }
  };

  return (
    <Input.Password
      size="large"
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
};

export default InputPassword;
